import ListIndex from './List/Index'
import CategoriesIndex from './Categories/Index'

const Index = () => {

    const currentUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}

    return (
        <>
        <ul className="nav nav-pills mb-3 mt-4" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
                <button className="nav-link py-3 mb-1 px-5 active" data-bs-toggle="pill" data-bs-target="#list" type="button" role="tab" aria-controls="list" aria-selected="true">لیست تیکت ها</button>
            </li>
            {currentUser?.roleId == 1 || currentUser?.roleId == 263 ? <li className="nav-item" role="presentation">
                <button className="nav-link py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#categories" type="button" role="tab" aria-controls="categories" aria-selected="false">موضوعات</button>
            </li> : ''}
        </ul>
        <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="list" role="tabpanel" aria-labelledby="list-tab" tabindex="0">
                <ListIndex />
            </div>
            <div className="tab-pane fade" id="categories" role="tabpanel" aria-labelledby="categories-tab" tabindex="0">
                <CategoriesIndex />
            </div>
        </div>
        </>
    )
}

export default Index